import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ConfigLoaderService } from 'src/app/Shared/Services/Config/config-loader.service';
import { SpoolDownloadService } from 'src/app/Shared/Services/SpoolDownload/spooldownload.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SpoolDownload,FileDownloadpath } from 'src/app/Shared/Model/spooldownload/spooldownload.model';
import { HttpEventType } from '@angular/common/http';
declare var $: any;
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';

@Component({
  selector: 'app-spooldownload-modal',
  templateUrl: './spooldownload-modal.component.html',
  styleUrls: ['./spooldownload-modal.component.scss']
})
export class SpooldownloadModalComponent implements OnInit {

  hasData: boolean = false;
  DataAvaialble: boolean = true;
  loading: boolean = true;
  userid!: string;
  displayedColumns!: string[];
  spoolDownloadlst!: SpoolDownload[];
  spoolDownloadListMatTabDataSource = new MatTableDataSource<SpoolDownload>(this.spoolDownloadlst);
  progresspercent!:string;
  filepath!: FileDownloadpath;
  filedownload = {status: '', progressPercent: ''};
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  showProgressBar:boolean=false;
  showalertMsg: boolean = false;
  alertMsg!:string;
  alertmsgClass!: string;
  showtoastError:boolean=false;
  showtoastSuccess:boolean=false;

  constructor(
    private _spoolDownloadService: SpoolDownloadService,
    private _configLoaderService: ConfigLoaderService,
     public modalRef: MDBModalRef,

  ) {

    this.filepath = new FileDownloadpath();

    }

  ngOnInit(): void {

    this.userid=ConfigLoaderService.settings.AppSettings.userId;    
    this.getSpoolDownloadList(this.userid);
  }


  getSpoolDownloadList(userId: string) {

    this._spoolDownloadService.getSpoolDownloadList(userId)
      .subscribe(
        data => {        
          this.spoolDownloadlst = data;
          if (!this.isEmpty(data)) {
    
            this.loading=false;
            this.spoolDownloadListMatTabDataSource.data = this.spoolDownloadlst;
            this.spoolDownloadListMatTabDataSource.sort = this.sort;
            this.spoolDownloadListMatTabDataSource.paginator = this.paginator;
            this.hasData = true;
            this.displayedColumns = ['UserId', 'Client','UploadFileName','Email_Id','Created_Date','UploadFilePath'];

          }
          else{
            this.loading=false;
            this.DataAvaialble = false; 
          } 
        },
        error => {         
          this.DataAvaialble = false;
          this.loading=false;
          this.hasData=false;
        }

      )

      }

      downloadFile(linkName:string, filename: string) {  
        this.loading=true;
  
        this.filepath.Filepath = linkName;
        this.filepath.Filename =filename;
        this._spoolDownloadService.getFile(this.userid,this.filepath).subscribe(
         event => {
           var message= this.getStatusMessage(event,linkName)   
           if(message.toLowerCase()=="done"){
            this.loading=false;
             this.filedownload.progressPercent="100";
             this.showProgressBar=false;
             $("#success").toast("show");
             this.alertmsgClass = 'alert alert-success';
             this.alertMsg = "File Download Completed";
             this.showalertMsg = true;
             this.showtoastSuccess=true;
           }
         },
         (error)=>{
          this.filedownload.status="Error";
          this.alertmsgClass = 'alert alert-danger';
          this.alertMsg = "Error in FileDownlaod"
          this.showalertMsg = true;  
          this.showtoastError=true;        
          $("#error").toast("show");

         }   
       )      
        
     }
   
     generateDownload(data: Blob, linkName: string) {
       saveAs(data, this.filepath.Filename); // from file-saver library   
      
     }

     getStatusMessage(event:any,linkName:string){
      let status;
  
      switch(event.type){
        case HttpEventType.Sent:
          return 'Uploading Files';
        
        case HttpEventType.UploadProgress:
          status = Math.round(100 * event.loaded / event.total);
          return 'Files are '+status+'% uploaded';
  
        case HttpEventType.DownloadProgress:
          status = Math.round(100 * event.loaded / event.total);
         this.filedownload.status="InProgress"
         this.filedownload.progressPercent=status.toString();
         this.showProgressBar=true;
          return 'Files are '+status+'% downloaded'; 
  
        case HttpEventType.Response:       
           this.generateDownload(event.body!,linkName)
           this.filedownload.status="Completed";
          return 'Done';
  
        default:
          return 'Something went wrong'
      }
    }
  

      applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.spoolDownloadListMatTabDataSource.filter = filterValue.trim().toLowerCase();
      }
    

      isEmpty(obj:any) {
        for (var key in obj) {
          if (obj.hasOwnProperty(key))
            return false;
        }
        return true;
      }

}
